import React, { useContext } from "react";
import LearningModulesContext from "./LearningModulesContext";

export const useLearningModules = () => {
  return useContext(LearningModulesContext)
};